// LinedSection.jsx
import React, { useMemo } from "react";
import styles from "./LinedSection.module.css";

/**
 * "Falling Glow Lines" / Matrix Rain style animation overlay.
 * Renders animated falling orange glow lines over the hero section.
 *
 * Usage:
 * <LinedSection>
 *   <h2>...</h2>
 * </LinedSection>
 */
export default function LinedSection({
  children,
  density = 40, // number of rain lines
}) {
  const lines = useMemo(
    () =>
      Array.from({ length: density }).map((_, i) => ({
        id: i,
        left: `${((i * (100 / density)) + (i % 5) * 0.7) % 100}%`,
        height: `${14 + (i % 9) * 4}px`,
        delay: `${(i % 13) * 0.3}s`,
        duration: `${2.6 + (i % 8) * 0.4}s`,
        opacity: 0.2 + (i % 6) * 0.08,
      })),
    [density]
  );

  return (
    <section className={styles.wrap} aria-hidden="true">
      {/* grid overlay */}
      <div className={styles.grid} />

      {/* subtle vignette */}
      <div className={styles.vignette} />

      {/* falling glow lines */}
      <div className={styles.rain}>
        {lines.map((l) => (
          <span
            key={l.id}
            className={styles.rainLine}
            style={{
              left: l.left,
              height: l.height,
              opacity: l.opacity,
              animationDuration: l.duration,
              animationDelay: l.delay,
            }}
          />
        ))}
      </div>

      <div className={styles.content}>{children}</div>
    </section>
  );
}